import React, { useEffect, useState } from "react";

interface DelayComponentRenderProps {
  children: JSX.Element;
  delayTime: number;
}

function DelayComponentRender({
  children,
  delayTime,
}: DelayComponentRenderProps) {
  const [shouldRender, setShouldRender] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setShouldRender(true);
    }, delayTime);
  });

  return shouldRender ? children : <></>;
}

export default DelayComponentRender;
